import { schema } from "normalizr"
import customerSchema from "./item"

export default new schema.Array(customerSchema)
